import { gsap } from 'gsap';




let myListCards = [];

let savedList;
const getSavedList = () => {
  if (!savedList) {
    savedList = JSON.parse(localStorage.getItem('savedList')) || [];
  }
  return savedList;
};

document.addEventListener('DOMContentLoaded', () => {
    init();
    initAccordion();
    initPaginationAndFilters();
    if (document.getElementById('active-filter-click')) {
        document.getElementById('active-filter-click').click()
    };
    let lazyImages = [].slice.call(document.querySelectorAll("img.lazyload"));

    let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.remove("lazyload");
            lazyImageObserver.unobserve(lazyImage);
        }
        });
    });

    lazyImages.forEach(function(lazyImage) {
        lazyImageObserver.observe(lazyImage);
    });
    });

const init = () => {
    if (document.getElementById('fav-pop')) setTimeout(initFavPop(),0);
    if (document.getElementById('talent')) setTimeout(initTalent(),0);
    if (document.getElementById('clearList')) setTimeout(initClearList(),0);
    if (document.querySelectorAll('.addToMyList').length > 0) setTimeout(initAddToMyList(),0);
    if (document.querySelector('[data-video]')) setTimeout(initTalentVideo(),0);
    initNav();
};

const initFavPop = () => {


    document.querySelectorAll('.close-fav').forEach(button => {
        button.addEventListener('click', () => {
             document.getElementById('fav-pop').classList.add('opacity-0', 'h-0');
        });
    });

    document.querySelectorAll('.open-fav').forEach(button => {
        button.addEventListener('click', () => {
            document.getElementById('fav-pop').classList.remove('opacity-0', 'pointer-events-none', 'h-0');
        });
    });
};

const initTalent = () => {
    const savedItemsInput = document.getElementById('talent');
    savedItemsInput.value = getSavedList().join(', ');
};

const initClearList = () => {
    const clearButton = document.getElementById('clearList');
    clearButton.addEventListener('click', () => {
        localStorage.removeItem('getSavedList()');
        document.getElementById('enquirecount').style.display = 'none';
        document.querySelectorAll('.addToMyList.inList').forEach(button => {
            button.classList.remove('inList');
            button.classList.add('notinList');
        });
    });
};

const initAddToMyList = () => {
    cards = Array.from(document.querySelectorAll('#cards .card'));
    myListCards = Array.from(document.querySelectorAll('#myListCards .card'));

    document.querySelectorAll('.addToMyList').forEach(button => {
        const card = button.closest('.card');
        const cardId = card.getAttribute('data-name');
        button.addEventListener('click', () => {
            toggleInList(cardId, button);
        });

        updateButtonClass(button, cardId);
    });

    document.querySelectorAll('.addOnlyToMyList').forEach(button => {
        const card = button.closest('.card');
        const cardId = card.getAttribute('data-name');
        button.addEventListener('click', () => {
            addOnlyInList(cardId, button);
        });

        updateButtonClass(button, cardId);
    });

    updateMyListCards();
};

const initTalentVideo = () => {
    const talentVideos = document.querySelectorAll('[data-video]');
    if (talentVideos.length === 0) return;

    // Load YouTube API script
    const tag = document.createElement('script');
    tag.src = "https://www.youtube.com/player_api";
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Define the onYouTubeIframeAPIReady function
    window.onYouTubeIframeAPIReady = () => {
        talentVideos.forEach((talentVideo, index) => {
            const videoId = getYouTubeVideoId(talentVideo.dataset.video);
            if (!videoId) return;

            const playerId = `youtube-player-${index}`;
            talentVideo.id = playerId;

            new YT.Player(playerId, {
                videoId: videoId,
                playerVars: {
                    'playsinline': 1,
                    'controls': 1,
                    'fs': 1,
                    'showinfo': 0,
                    'rel': 0,
                    'modestbranding': 1,
                    'iv_load_policy': 3,
                    'enablejsapi': 1,
                    'origin': window.location.origin
                },
                events: {
                    'onReady': onPlayerReady
                }
            });
        });
    };
};

// Helper function to extract YouTube video ID from URL
const getYouTubeVideoId = (url) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
};

// onPlayerReady event handler (you can customize this as needed)
const onPlayerReady = (event) => {
    // You can add any specific actions you want to perform when the player is ready
    console.log('YouTube player is ready');
};

const initNav = () => {
    const open = document.getElementById('opendropdown');
    const openmb = document.getElementById('opendropdown-mb');
    const mbNav = document.getElementById('open-mb');


    document.querySelectorAll('.open-search').forEach(i => toggleSearchBar(i));


    let isOpen = false
    let isOpenMB = false
    let isOpenMBDrop = false
    let isOpenSearch = false

    const tlnavOpen = gsap.timeline({paused: true});
    tlnavOpen.fromTo('#header',{
        background: 'white'
    },
    {
        background: 'linear-gradient(146deg, #D80861 0%, #53176E 100%)'
    },+0.2) 
    tlnavOpen.to('.logo-color',{
        opacity:0
    },+0.2)
    tlnavOpen.to('.logo-white',{
        opacity:1
    },+0.2)
    tlnavOpen.to('#arrow',{
        rotate: 180
    },+0.2)
    tlnavOpen.to('#arrow',{
        rotate: 180,
        color: 'white'
    },+0.2)
     tlnavOpen.to('#arrow',{
        rotate: 180,
        stroke: 'white'
    },+0.2)
     tlnavOpen.to('.rainbow-button svg path',{
        fill: 'white'
    },+0.2)
     tlnavOpen.to('.rainbow-button span',{
        color: 'white'
    },+0.2)
     tlnavOpen.to('#arrow path',{
        stroke: 'white'
    },+0.2)
    tlnavOpen.to('.navtext',{
        color: 'white'
    },+0.2)
    tlnavOpen.to('.buttonline',{
        opacity: 1
    },+0.2)
    tlnavOpen.fromTo('#dropdown',{
        height:'0'
    },{
        height:'auto'
    },+0.2)
    
    const tlnavOpenSearch = gsap.timeline({paused: true});
    tlnavOpenSearch.fromTo('#search',{
        height:'0'
    },
    {
       height:'auto'
    }) 

     const tlnavOpenMB = gsap.timeline({paused: true});
    tlnavOpenMB.fromTo('#mb-nav',{
        height:'0'
    },
    {
       height:'auto'
    }) 

    const tlnavOpenMBDrop = gsap.timeline({paused: true});
    tlnavOpenMBDrop.fromTo('#dropdown-mb',{
        height:'0'
    },
    {
       height:'auto'
    }) 



    open.addEventListener('click', function () {
        isOpen = !isOpen
        if(isOpen){
            tlnavOpen.play()
        }
        else{
            tlnavOpen.reverse()
        }
    })

    openmb.addEventListener('click', function () {
        isOpenMBDrop = !isOpenMBDrop
        if(isOpenMBDrop){
            tlnavOpenMBDrop.play()
        }
        else{
            tlnavOpenMBDrop.reverse()
        }
    })

    mbNav.addEventListener('click', function () {
        isOpenMB = !isOpenMB
        if(isOpenMB){
            tlnavOpenMB.play()
        }
        else{
            tlnavOpenMB.reverse()
        }
    })

    function toggleSearchBar(i)
    {
        i.addEventListener('click', function () {
            isOpenSearch = !isOpenSearch
            if(isOpenSearch){
                tlnavOpenSearch.play()
            }
            else{
                tlnavOpenSearch.reverse()
            }
        })
    }
};

const toggleInList = (cardId, button) => {
    const index = getSavedList().indexOf(cardId);

    if (index === -1) {
        getSavedList().push(cardId);
        button.classList.remove('notinList');
        button.classList.add('inList');
        document.getElementById('fav-pop').classList.remove('opacity-0')
        document.getElementById('fav-pop').classList.remove('pointer-events-none')
        document.getElementById('fav-pop').classList.remove('h-0')
    } else {
        getSavedList().splice(index, 1);
        button.classList.remove('inList');
        button.classList.add('notinList');
    }

    localStorage.setItem('savedList', JSON.stringify(getSavedList()));
    updateMyListCards();
};

const addOnlyInList = (cardId, button) => {
    const index = getSavedList().indexOf(cardId);

    if (index === -1) {
        getSavedList().push(cardId);
        button.classList.remove('notinList');
        button.classList.add('inList');
        // Your code for displaying pop-up or whatever you want to do
        document.getElementById('fav-pop').classList.remove('opacity-0');
        document.getElementById('fav-pop').classList.remove('pointer-events-none');
        document.getElementById('fav-pop').classList.remove('h-0');
    }

    localStorage.setItem('savedList', JSON.stringify(getSavedList()));
    updateMyListCards();
};

const updateButtonClass = (button, cardId) => {
    if (getSavedList().includes(cardId)) {
        button.classList.remove('notinList');
        button.classList.add('inList');
    } else {
        button.classList.remove('inList');
        button.classList.add('notinList');
    }
};

const updateMyListCards = () => {
    const getEnqire = document.getElementById('enquirecount');
    const getEnqireText = document.getElementById('enquirecount-text');

    getEnqire.style.display = getSavedList().length > 0 ? 'block' : 'none';
    getEnqireText.innerText = getSavedList().length


    myListCards.forEach(card => card.style.display = 'none');

    getSavedList().forEach(id => {
        const matchingCard = document.querySelector(`#myListCards .card[data-name="${id}"]`);
        if (matchingCard) {
            matchingCard.style.display = '';
            matchingCard.querySelectorAll('.notinList').forEach(button => {
                button.classList.remove('notinList');
                button.classList.add('inList');
            });
        }
    });
};



  
  const getEmbedUrl = (url) => {
    let youtube, vimeo
    const youtubeRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
    const vimeoRegExp = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i
    if (url.match(youtubeRegExp)) {
      youtube = url.match(youtubeRegExp)[2]
    } else if (url.match(vimeoRegExp)) {
      vimeo = url.match(vimeoRegExp)[1]
    }
  
    if (youtube && youtube.length === 11) {
      // Added parameters for controls, fullscreen, and progress bar
      return `https://www.youtube.com/embed/${youtube}?controls=1&fs=1&showinfo=0`
    } else if (vimeo) {
      return 'https://player.vimeo.com/video/' + vimeo
    } else {
      console.error('Provide a valid YouTube or Vimeo URL')
      return null
    }
  }

  function initAccordion() {
  const groups = gsap.utils.toArray(".accordion-group");
  if (!groups.length) return;

  const menuToggles = groups.map(createAnimation);
  gsap.utils.toArray(".accordion-menu").forEach((menu) => {
    menu.addEventListener("click", () => toggleMenu(menu, menuToggles));
  });
}

function toggleMenu(clickedMenu, menuToggles) {
  menuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
}

function createAnimation(element) {
  const menu = element.querySelector(".accordion-menu");
  const box = element.querySelector(".accordion-content");
  const plusElement = element.querySelector(".accordion-plus");

  gsap.set(box, { height: "auto" });
  const animation = gsap.timeline()
    .from(box, { height: 0, duration: 0.5, ease: "power1.inOut" })
    .to(plusElement, { duration: 0.5, rotate: 180, ease:"none" }, 0)
    .reverse();

  return (clickedMenu) => {
    if (clickedMenu === menu) {
      animation.reversed(!animation.reversed());
    }
  };
}

function initPaginationAndFilters() {
  let cards = Array.from(document.querySelectorAll('#cards .card'));
  let visibleCards = [];
  let currentPage = 1;
  const cardsPerPage = 12;

  if (cards.length) {
    updateCardsVisibility();
  }

  function updateCardsVisibility() {
    // Extract and execute common code
    const checkedValues = (selector) => Array.from(document.querySelectorAll(selector + ':checked')).map(checkbox => checkbox.value);
    const checkedTopics = checkedValues('.topicCheckbox');
    const checkedSubtopics = checkedValues('.subtopicCheckbox');
    const checkedTypes = checkedValues('.typeCheckbox');

    visibleCards = cards.filter(card => {
      const hasChecked = (attribute, checkedArray) => {
        const cardArray = JSON.parse(card.getAttribute('data-' + attribute));
        return checkedArray.length === 0 || checkedArray.some(value => cardArray.includes(value));
      };

      return hasChecked('topic', checkedTopics) && hasChecked('subtopic', checkedSubtopics) && hasChecked('type', checkedTypes);
    });

    currentPage = 1;
    updatePagination();
  }

  function updatePagination() {
    cards.forEach(card => card.style.display = 'none');
    const startIndex = (currentPage - 1) * cardsPerPage;
    const endIndex = startIndex + cardsPerPage;
    const currentCards = visibleCards.slice(startIndex, endIndex);
    currentCards.forEach(card => card.style.display = '');
    updatePageInfo();
  }

  function updatePageInfo() {
    document.getElementById('currentPage').textContent = `${currentPage} / ${Math.ceil(visibleCards.length / cardsPerPage)}`;
    document.getElementById('prevPage').disabled = currentPage === 1;
    document.getElementById('nextPage').disabled = currentPage === Math.ceil(visibleCards.length / cardsPerPage);
  }

  // Attach event listeners if the elements are found
  const attachEvents = (selector, eventFunction) => {
    const elements = document.querySelectorAll(selector);
    if (elements.length) {
      elements.forEach(element => element.addEventListener('change', eventFunction));
    }
  };

  attachEvents('.topicCheckbox', updateCardsVisibility);
  attachEvents('.subtopicCheckbox', updateCardsVisibility);
  attachEvents('.typeCheckbox', updateCardsVisibility);

  const prevPage = document.getElementById('prevPage');
  const nextPage = document.getElementById('nextPage');

  if (prevPage && nextPage) {
    prevPage.addEventListener('click', () => {
      currentPage--;
      updatePagination();
      window.scrollTo(0, 0);
    });
    nextPage.addEventListener('click', () => {
      currentPage++;
      updatePagination();
      window.scrollTo(0, 0);
    });
  }
}